'use client';

import React from 'react';

const EnterpriseGovernment = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            Enterprise and Government Contexts
          </h2>

          <div className="space-y-12">
            <div>
              <h3 className="text-3xl font-bold text-[#0A2540] mb-6">Enterprise Organisations</h3>
              <div className="space-y-6 text-lg text-gray-800 font-body leading-relaxed">
                <p>
                  In enterprise contexts, AI Change Leadership addresses the challenges of competitive pressure, scale, and speed. Organisations must adopt AI rapidly while maintaining operational continuity, managing workforce transitions, and evolving operating models to sustain competitive advantage.
                </p>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Competitive Pressure</h4>
                    <p className="text-gray-700">Speed of adoption determines market position and strategic advantage.</p>
                  </div>
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Scale and Speed</h4>
                    <p className="text-gray-700">Enterprise-wide transformation requires coordinated change across functions and geographies.</p>
                  </div>
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Workforce Augmentation</h4>
                    <p className="text-gray-700">Roles, skills, and career pathways must evolve as AI augments human work.</p>
                  </div>
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Operating Model Evolution</h4>
                    <p className="text-gray-700">Structures, processes, and governance must adapt to enable continuous change.</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-[#0A2540] mb-6">Government and Public Institutions</h3>
              <div className="space-y-6 text-lg text-gray-800 font-body leading-relaxed">
                <p>
                  In government and public sector contexts, AI Change Leadership addresses the unique requirements of public accountability, policy environments, ethical considerations, and long-term service transformation. Public institutions must balance innovation with risk management, transparency, and societal trust.
                </p>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Public Trust and Accountability</h4>
                    <p className="text-gray-700">AI adoption must maintain public confidence and demonstrate responsible stewardship.</p>
                  </div>
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Policy and Regulatory Environments</h4>
                    <p className="text-gray-700">Change must align with legislative frameworks and regulatory requirements.</p>
                  </div>
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Ethical and Societal Implications</h4>
                    <p className="text-gray-700">AI deployment requires careful consideration of fairness, bias, and societal impact.</p>
                  </div>
                  <div className="bg-gray-50 p-6 border-l-4 border-[#0A2540]">
                    <h4 className="font-bold text-[#0A2540] mb-2">Long-Term Service Transformation</h4>
                    <p className="text-gray-700">Public services must evolve sustainably across political cycles and leadership changes, with appropriate governance assurance.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 p-8 bg-gray-50 border-l-4 border-[#0A2540]">
              <p className="text-lg text-gray-800 leading-relaxed">
                While enterprise and government contexts differ in priorities and constraints, they share fundamental leadership challenges: aligning stakeholders, governing continuous change, building organisational capability, and sustaining transformation momentum. AI Change Leadership provides a common foundation for both.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseGovernment;